import axios from '@/store/interceptor';
import apiUrl from '../../config/api.config';

// ── Categories ──

export async function getCategories() {
    const response = await axios.get(`${apiUrl}/decontare/categories`);
    return response.data;
}

export async function createCategory(data) {
    const response = await axios.post(`${apiUrl}/decontare/categories`, data);
    return response.data;
}

export async function updateCategory(id, data) {
    const response = await axios.patch(`${apiUrl}/decontare/categories/${id}`, data);
    return response.data;
}

export async function deleteCategory(id) {
    const response = await axios.delete(`${apiUrl}/decontare/categories/${id}`);
    return response.data;
}

// ── Templates ──

export async function getTemplates() {
    const response = await axios.get(`${apiUrl}/decontare/templates`);
    return response.data;
}

export async function createTemplate(data) {
    const response = await axios.post(`${apiUrl}/decontare/templates`, data);
    return response.data;
}

export async function updateTemplate(id, data) {
    const response = await axios.patch(`${apiUrl}/decontare/templates/${id}`, data);
    return response.data;
}

export async function deleteTemplate(id) {
    const response = await axios.delete(`${apiUrl}/decontare/templates/${id}`);
    return response.data;
}

// ── Experts ──

export async function getExperts() {
    const response = await axios.get(`${apiUrl}/decontare/experts`);
    return response.data;
}

export async function createExpert(data) {
    const response = await axios.post(`${apiUrl}/decontare/experts`, data);
    return response.data;
}

export async function updateExpert(id, data) {
    const response = await axios.patch(`${apiUrl}/decontare/experts/${id}`, data);
    return response.data;
}

export async function deleteExpert(id) {
    const response = await axios.delete(`${apiUrl}/decontare/experts/${id}`);
    return response.data;
}

// ── PV Commission ──

export async function getPvCommission() {
    const response = await axios.get(`${apiUrl}/decontare/pv-commission`);
    return response.data;
}

export async function createPvCommission(data) {
    const response = await axios.post(`${apiUrl}/decontare/pv-commission`, data);
    return response.data;
}

export async function updatePvCommission(id, data) {
    const response = await axios.patch(`${apiUrl}/decontare/pv-commission/${id}`, data);
    return response.data;
}

export async function deletePvCommission(id) {
    const response = await axios.delete(`${apiUrl}/decontare/pv-commission/${id}`);
    return response.data;
}

// ── Settings ──

export async function getSettings() {
    const response = await axios.get(`${apiUrl}/decontare/settings`);
    return response.data;
}

export async function updateSettings(data) {
    const response = await axios.patch(`${apiUrl}/decontare/settings`, data, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

// ── Forms ──

export async function getTableData() {
    const response = await axios.get(`${apiUrl}/decontare/table-data`);
    return response.data;
}

export async function getSuggestions() {
    const response = await axios.get(`${apiUrl}/decontare/suggestions`);
    return response.data;
}

export async function getFormById(id) {
    const response = await axios.get(`${apiUrl}/decontare/${id}`);
    return response.data;
}

export async function createForm(postData) {
    const response = await axios.post(`${apiUrl}/decontare`, postData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

export async function updateFormFull(id, postData) {
    const response = await axios.patch(`${apiUrl}/decontare/update-full/${id}`, postData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

export async function updateForm(id, postData) {
    const response = await axios.patch(`${apiUrl}/decontare/${id}`, postData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

export async function deleteForm(id) {
    const response = await axios.delete(`${apiUrl}/decontare/${id}`);
    return response.data;
}

export async function confirmForm(id) {
    const response = await axios.patch(`${apiUrl}/decontare/confirm/${id}`);
    return response.data;
}

export async function updateInventoryStatus(invId, status) {
    const response = await axios.patch(`${apiUrl}/decontare/inventory-number/${invId}/status`, { status }, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}
